var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotoDropOfBlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6348 10.3729C17.6816 6.75176 16.3762 3.67207 15.6285 1.83457C15.3918 1.25566 14.6066 1.25566 14.3723 1.83457C13.6246 3.67207 12.3191 6.75176 9.36601 10.3729C7.5168 12.6416 5.69336 15.9627 5.69336 19.2346C5.69336 24.8174 9.72227 28.5979 15.0004 28.5979C20.2785 28.5979 24.3074 24.815 24.3074 19.2346C24.3074 15.8338 22.484 12.6416 20.6348 10.3729Z",
    fill: "#E5322E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5733 18.7118C19.0615 15.8806 18.8506 13.1102 20.0272 13.6095C21.6256 14.2915 23.3951 17.7954 22.7318 20.9712C22.2584 23.2352 20.7303 24.6063 18.7826 23.9524C17.21 23.4251 16.2326 21.2618 17.5733 18.7118Z",
    fill: "#FF6050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoDropOfBlood);
export default __webpack_public_path__ + "static/media/noto_drop-of-blood.635b58050477a4ec88aefee07aae1db7.svg";
export { ForwardRef as ReactComponent };